
export interface Referrer  {
  id?: string,
  Email?: string,
  Prefix?: string,
  FirstName?: string,
  LastName?: string,
  scope?: string,
  Phone?: string,
  ReferrerStatus?: string,
  ReferrerPhase?: string,  
  CreatedBy?: string
}
